module.exports = __webpack_public_path__ + "img/todoapp.675e88dd.jpg";